export const GRAMMAR = 1;
export const BLOG = 2;
export const NATIONAL_HIGHT_SCHOOL = 3;
export const TOEIC_P1 = 4;
export const TOEIC_P2 = 5;
export const TOEIC_P3 = 6;
export const TOEIC_P4 = 7;
export const TOEIC_P5 = 8;
export const TOEIC_P6 = 9;
export const TOEIC_P7 = 10;
export const TOEIC_MINI = 11;
export const TOEIC_FULL = 12;
export const CLASS_6 = 13;
export const CLASS_7 = 14;
export const CLASS_8 = 15;
export const CLASS_9 = 16;
export const CLASS_10 = 17;
export const CLASS_11 = 18;
export const CLASS_12 = 19;
export const IELT_LISTEN = 20;
export const IELT_READ = 21;
export const IELT_WRITE = 22;
export const IELT_SPEAK = 23;
export const DISABLE_SIZE_GROUP = [1, 3, 13, 14, 15, 16, 17, 18 ,19, 20, 21, 22, 23, 24, 25];
export const IELTS_TEST = [20, 21, 22, 23];
export const A1_TEST = 24;
export const B1_TEST = 25;
export const SPEAK_BASIC = 27;
